import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { environment } from 'src/environments/environment';
import { AuthFlowId } from '../models/auth-flow.models';
import { AuthActionsService } from '../services/auth-actions.service';
import { AuthFlowAnalyticsHelper } from '../helpers/auth-analytics.helper';
import { AuthFlowService } from '../services/auth-flow.service';
import { AuthSessionStore } from '../services/auth-session.store';

@Component({
  selector: 'app-auth-shell',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth-shell.page.html',
  styleUrls: ['./auth-shell.page.scss'],
})
export class AuthShellPage implements OnInit {
  readonly environment = environment;

  private readonly route = inject(ActivatedRoute);
  private readonly store = inject(AuthSessionStore);
  private readonly flow = inject(AuthFlowService);
  private readonly actions = inject(AuthActionsService);
  private readonly authAnalytics = inject(AuthFlowAnalyticsHelper);
  private readonly router = inject(Router);
  private readonly analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    const flowId = (this.route.snapshot.data['flowId'] as AuthFlowId) ?? AuthFlowId.Login;
    const pvzUuid = this.route.snapshot.paramMap.get('uuid');
    const redirect = this.route.snapshot.queryParamMap.get('redirect');

    this.flow.initFlow(flowId, pvzUuid, redirect);

    if (flowId === AuthFlowId.Pvz && !pvzUuid?.trim()) {
      this.authAnalytics.captureInvalidPvzLinkRedirect();
      void this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    if (flowId === AuthFlowId.Registration) {
      this.store.isNewUser.set(true);
    } else if (flowId === AuthFlowId.Login) {
      this.store.isNewUser.set(false);
    }

    if (pvzUuid && !this.actions.checkPvzDesktopOnly()) {
      return;
    }

    if (flowId === AuthFlowId.Pvz && pvzUuid) {
      void this.actions.loadPvzEmployees();
    }
  }

  ionViewDidEnter(): void {
    this.analyticsService.ymHit();
  }
}
